'use strict';

var createElement = require('@cloudcmd/create-element');

var noop = function noop() {};

load.addLoadListener = function (onload) {
  load.onload = onload;
};

load.addErrorListener = function (onerror) {
  load.onerror = onerror;
};

var addListenerOnce = function addListenerOnce(el, name, fn) {
  var listener = function listener(e) {
    fn(e);
    el.removeEventListener(name, fn);
  };

  el.addEventListener(name, listener);
};

load.onerror = noop;
load.onload = noop;
module.exports = load;

function load(src, callback) {
  var ext = getExt(src);

  switch (ext) {
    case '.js':
      return load.js(src, callback);

    case '.css':
      return load.css(src, callback);

    case '.json':
      return load.json(src, callback);

    default:
      return load.ajax(src, callback);
  }
}

load.js = function (src, callback) {
  var id = getIdBySrc(src);
  var el = document.getElementById(id);
  if (el) return callback();
  el = createElement('script', {
    id: id,
    src: src
  });
  addListenerOnce(el, 'load', function (event) {
    callback(null, event);
    load.onload();
  });
  addListenerOnce(el, 'error', function (e) {
    callback(e);
    document.body.removeChild(el);
    load.onerror(e, src);
  });
};

load.css = function (src, callback) {
  var id = getIdBySrc(src);
  var el = document.getElementById(id);
  if (el) return callback();
  el = createElement('link', {
    id: getIdBySrc(src),
    rel: 'stylesheet',
    href: src,
    parent: document.head
  });
  el.addEventListener('load', function (event) {
    callback(null, event);
    load.onload();
  });
  el.addEventListener('error', function (e) {
    callback(e);
    document.head.removeChild(el);
    load.onerror(e, src);
  });
};

load.ajax = function (url, callback) {
  var request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.addEventListener('load', function () {
    if (request.status >= 200 && request.status < 400) {
      var data = request.responseText;
      callback(null, data);
      load.onload();
    }
  });
  request.addEventListener('error', function (e) {
    load.onerror(e);
    callback(e);
  });
  request.send();
};

load.json = function (url, callback) {
  load.ajax(url, function (error, data) {
    var json;
    if (!error) json = JSON.parse(data);
    callback(error, json);
  });
};

load.series = function (urls, callback) {
  var url = urls.shift();
  if (!url) return callback();
  load(url, function (error) {
    if (error) return callback(error);
    load.series(urls, callback);
  });
};

load.parallel = function (urls, callback) {
  var i = urls.length;
  var done;

  var func = function func(error) {
    --i;

    if (!i && !done || error) {
      done = true;
      callback(error);
    }
  };

  urls.forEach(function (url) {
    load(url, func);
  });
};

function getExt(name) {
  var isStr = typeof name === 'string';
  var ret = '';
  var dot;

  if (isStr) {
    dot = name.lastIndexOf('.');
    if (~dot) ret = name.substr(dot);
  }

  return ret;
}

load.getIdBySrc = getIdBySrc;

function getIdBySrc(src) {
  var num, sub, id;
  var isStr = typeof src === 'string';
  if (!isStr) return '';
  if (~src.indexOf(':')) src += '-join';
  num = src.lastIndexOf('/') + 1;
  sub = src.substr(src, num);
  id = src.replace(sub, '').replace(/\./g, '-');
  return id;
}